import React from 'react'

const CheckboxField = ({ className, label, disabled, meta, input }) => {
  const { touched, error } = meta || {}
  const { value, onChange, onFocus, onBlur } = input
  return (
    <div className={`md-field`}>
      <div className="flex-check">
        <input
          defaultChecked={value}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className={className}
          type={'checkbox'}
          disabled={disabled}
        />
        {label && <span style={{ display: 'block' }}>{label}</span>}
      </div>
      {touched && error && <div className="error">{error}</div>}
    </div>
  )
}

export default CheckboxField
